// extracted by mini-css-extract-plugin
module.exports = {"header":"AlertsOverviewTab_header__2czvX","headerWrapper":"AlertsOverviewTab_headerWrapper__KikQt"};